import { action, computed, extendObservable, observable } from 'mobx';
import { cadastreUrbanProps } from '../cadastreFields';

export class SaleEditStore {
  @observable page = 1;
  @observable offerData = {};
  @observable docs = [];

  @computed get isPage1Valid() {
    const data = this.offerData;
    return !!data.object_type && !!data.object_address;
  }

  @computed get isPage2Valid() {
    // const data = this.offerData;
    return true;
  }

  @computed get isPage3Valid() {
    return true;
  }

  @action initialize(offerData, docs) {
    this.offerData = Object.assign({}, offerData);
    this.docs = (docs || []).slice();
    extendObservable(this.offerData, {
      // Page1
      object_type: offerData.object_type || '',
      object_address_street: offerData.object_address_street || '',
      object_address_house_number: offerData.object_address_house_number || '',
      object_address_apartment_number:
        offerData.object_address_apartment_number || '',
      object_address_state: offerData.object_address_state || '',
      object_address_zip: offerData.object_address_zip || '',
      object_owner: offerData.object_owner || '',
      object_usage: offerData.object_usage || '',
      object_composition: offerData.object_composition || '',
      object_provenance_type: offerData.object_provenance_type || '',
      object_provenance_date: offerData.object_provenance_date || '',
      object_provenance_notary: offerData.object_provenance_notary || '',
      object_provenance_detail: offerData.object_provenance_detail || '',
      cadastral_municipality: offerData.cadastral_municipality || '',
      cadastre_urban:
        offerData.cadastre_urban || observable([{ ...cadastreUrbanProps() }]),
      cadastre_land: offerData.cadastre_land || observable([]),
      occupation_type: offerData.occupation_type || '',
      occupation_rent_name: offerData.occupation_rent_name || '',
      occupation_rent_amount: offerData.occupation_rent_amount || '',
      occupation_rent_expiration: offerData.occupation_rent_expiration || '',
      object_cadastral_compliance: offerData.object_cadastral_compliance || '',
      object_regulation_compliance:
        offerData.object_regulation_compliance || '',
      object_usability_compliance_equiped:
        offerData.object_usability_compliance_equiped || false,
      object_usability_compliance_indemnification:
        offerData.object_usability_compliance_indemnification || false,
      administration_costs_annual: offerData.administration_costs_annual || 0,
      administration_costs_extra: offerData.administration_costs_extra || 0,
      administration_costs_heating_included:
        offerData.administration_costs_heating_included || false,
      seller_notes: offerData.seller_notes || '',
      debt_type: offerData.debt_type || 'none',
      debt_amount: offerData.debt_amount || '',
      debt_details: offerData.debt_details || '',

      // Page2
      seller_type: offerData.seller_type || 'private',
      seller_company_name: offerData.seller_company_name || '',
      seller_vat_id: offerData.seller_company_vat_id || '',
      seller_firstName: offerData.seller_firstName || '',
      seller_lastName: offerData.seller_lastName || '',
      seller_dob: offerData.seller_dob || '',
      seller_pob: offerData.seller_pob || '',
      seller_street: offerData.seller_street || '',
      seller_house_number: offerData.seller_house_number || '',
      seller_street_additional: offerData.seller_street_additional || '',
      seller_zip: offerData.seller_zip || '',
      seller_city: offerData.seller_city || '',
      seller_country: offerData.seller_country || 'Italia',
      seller_country_code: offerData.seller_country_code || 'IT',
      additional_sellers: offerData.additional_sellers || [],
      deposit_type: offerData.deposit_type || '',
      deposit_fixed_amount: offerData.deposit_fixed_amount || '',
      deposit_percentage: offerData.deposit_percentage || '',
      tranches: offerData.tranches || observable([]),
      handover: offerData.handover || '',
      due_diligence_deadline_days: offerData.due_diligence_deadline_days || '',
      court: offerData.court || '',
      deposit_transfer_iban: offerData.deposit_transfer_iban || '',
      deposit_transfer_bank: offerData.deposit_transfer_bank || '',
      deposit_transfer_owner: offerData.deposit_transfer_owner || '',
      deposit_transfer_duration: offerData.deposit_transfer_duration || 7,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_it/stores/index.js